module.exports = __webpack_public_path__ + "img/2-2.8ed8180a.png";